import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";

import InputMessage from "./Message";
import Icon from "components/Icon";
import { noop } from "lodash-es";

const Control = ({
    invalidFields,
    label,
    id,
    children,
    error,
    errorMessage,
    name,
    classes,
    message,
    icon,
    validationName,
    frontendValidation,
    onClickIcon,
}) => {
    const _name = validationName ? validationName : name;
    const flattenName =
        !!_name && _name.split(`]`).join(``).split(`[`).join(`.`);

    return (
        <div
            className={cn(
                "form-input",
                {
                    "form-input--invalid":
                        (!!invalidFields && invalidFields.has(flattenName)) ||
                        errorMessage ||
                        frontendValidation,
                },

                { "form-input--with-icon": icon },
                classes.container
            )}
        >
            {icon && (
                <div className="icon-container" onClick={onClickIcon}>
                    <Icon type={icon} />
                </div>
            )}

            {label && (
                <label htmlFor={id} className="form-input__label">
                    {label}
                </label>
            )}

            <div className={cn("form-input__control", classes.control)}>
                {children}
            </div>

            <InputMessage
                frontendValidation={frontendValidation}
                flattenName={flattenName}
                error={error}
                message={message}
            />
        </div>
    );
};

Control.defaultProps = {
    classes: {},
    onClickIcon: noop,
};

Control.propTypes = {
    invalidFields: PropTypes.instanceOf(Set).isRequired,
    label: PropTypes.string,
    id: PropTypes.number.isRequired,
    children: PropTypes.node,
    error: PropTypes.array,
    errorMessage: PropTypes.string,
    message: PropTypes.string,
    icon: PropTypes.string,
    name: PropTypes.string,
    validationName: PropTypes.string,
    frontendValidation: PropTypes.string,
    required: PropTypes.bool,
    classes: PropTypes.shape({
        container: PropTypes.string,
        control: PropTypes.string,
    }),
    onClickIcon: PropTypes.func,
};

export default Control;
